import { withHTMLHeadSEO } from 'components/common';
import AssignmentDemo from 'components/common/assignment-demo/AssignmentDemo';

const CaseStudyDemoPage = () => <AssignmentDemo />;

export { CaseStudyDemoPage as BaseCaseStudyDemoPage };
export default withHTMLHeadSEO({ title: 'Case study demo' })(CaseStudyDemoPage);
